import { render, staticRenderFns } from "./serviceConfig.vue?vue&type=template&id=35a31816&scoped=true"
import script from "./serviceConfig.vue?vue&type=script&lang=ts"
export * from "./serviceConfig.vue?vue&type=script&lang=ts"
import style0 from "./serviceConfig.vue?vue&type=style&index=0&id=35a31816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a31816",
  null
  
)

export default component.exports